import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/element';
import VueCytoscape from 'vue-cytoscape'
import { i18n } from './plugins/i18n'
import VueMeta from 'vue-meta'
import VueGtag from 'vue-gtag';


Vue.use(VueMeta)
Vue.use(VueGtag, {
  config: {
    id: 'G-L858EWFGQP'
  }
})
// Vue.use(VueAnalytics, {
//   id: 'G-L858EWFGQP'
// })
Vue.use(VueCytoscape)
Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
